<template>
    <b-modal centered
             hide-footer
             content-class="rounded-0"
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal">
        <template v-slot:modal-title>
            Reauthenticate
        </template>

        <slot></slot>

        <div class="form-row">
            <b-form-group class="col-md-12"
                          label-for="challenge"
                          label="Password"
                          invalid-feedback="Incorrect credential. "
                          v-bind:state="challengeValid">
                <b-input-group>
                    <b-form-input id="challenge"
                                  required
                                  v-bind:type="challengeType"
                                  v-bind:state="challengeValid"
                                  v-model="challengeReply"
                                  v-on:focus="challengeValid = challengeValid === false ? null : challengeValid">
                    </b-form-input>
                    <b-input-group-append>
                        <button class="btn btn-danger"
                                v-bind:class="{ 'btn-loading': isLoading }"
                                v-bind:disabled="!allowConfirm"
                                v-on:click="confirm">
                            Confirm
                        </button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import {
    BModal,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
} from "bootstrap-vue";

import login from "../../api/admin/login";

export default {
    name: "ModalReAuthenticate",
    components: {
        BModal,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BInputGroupAppend,
    },
    props: {
        "value": {
            type: Boolean,
        },
        "email": {
            type: String,
            required: true,
        },
        "challengeType": {
            type: String,
            default: "text",
        },
        "callback": {
            type: Function,
            required: true,
        }
    },
    data () {
        return {
            isLoading: false,

            challengeValid: null,
            challengeReply: "",
        };
    },
    computed: {
        allowConfirm () {
            return !!this.challengeReply;
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
        reset () {
            this.challengeReply = "";
        },
        async confirm () {
            const { email, challengeReply, } = this;
            this.isLoading = true;
            try {
                await login({ email, "password": challengeReply });
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                this.challengeValid = false;
                this.challengeReply = "";
                return;
            }
            this.challengeValid = true;
            this.isLoading = false;
            if (typeof this.callback === "function") {
                this.callback();
            }
            this.reset();
            this.hideModal();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
